// extracted by mini-css-extract-plugin
export var backToTop = "ScrollToTopButton-module--back-to-top--5b26a";
export var backToTopIcon = "ScrollToTopButton-module--back-to-top-icon--612d6";